import { z } from 'zod';
import { paginationSchema } from './pagination';

export const brandUrlsSchema = z.object({
  home: z.string(),
  contactUs: z.string(),
  termsAndConditions: z.string(),
  privacyPolicy: z.string(),
  requestDemo: z.string(),
  knowledgeBase: z.string(),
  reportIssue: z.string(),
  reportFeature: z.string(),
  support: z.string(),
  bulkImportHelp: z.string(),
  calendarSyncHelp: z.string(),
});

export const brandContactsSchema = z.object({
  salesPhone: z.object({
    display: z.string(),
    href: z.string(),
  }),
});

export const appFeaturesSchema = z.object({
  disablePayment: z.boolean().default(false),
  disableSignUp: z.boolean().default(false),
  integrationAppEnabled: z.boolean(),
  contactUsIntegrationsEnabled: z.boolean(),
});

export const appConfigSchema = z.object({
  brandName: z.string().default('RepMove'),
  termsAndPrivacyUpdatedAt: z.number(),
  defaultTheme: z.string().optional(),
  downloadAppQRUrl: z.string().optional(),
  pagination: paginationSchema,
  features: appFeaturesSchema,
  brandUrls: brandUrlsSchema,
  brandContacts: brandContactsSchema,
});

export type AppConfig = z.infer<typeof appConfigSchema>;
